class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('#search-input');
    this.predictiveSearchResults = document.querySelector('#search-results');

    this.input.addEventListener(
      'input',
      this.debounce((event) => {
        this.onChange(event);
      }, 300).bind(this),
    );
  }

  onChange() {
    const searchTerm = encodeURIComponent(this.input.value.trim());

    if (!searchTerm.length) {
      $(this.predictiveSearchResults).fadeOut(function () {
        $('.search__initial').fadeIn();
      });

      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    // Make both fetch requests in parallel
    const productCountPromise = fetch(
      `/search?q=${searchTerm}&type=product,article&options[unavailable_products]=show&options[prefix]=last&view=predictive`,
    )
      .then((response) => response.text())
      .then((text) => {
        // Extract the product count from the response
        const countMatch = text.match(/(\d+)\s+Products?/i);
        return countMatch && countMatch[1] ? parseInt(countMatch[1], 10) : 0;
      });

    const searchResultsPromise = fetch(
      `${window.Shopify.routes.root}search/suggest?q=${searchTerm}&resources[type]=product,collection,page&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,variants.title&section_id=predictive-search`,
    ).then((response) => {
      if (!response.ok) {
        return response.text().then((text) => {
          throw new Error(`${response.status}: ${text}`);
        });
      }
      return response.text();
    });

    // Wait for both promises to resolve
    Promise.all([productCountPromise, searchResultsPromise])
      .then(([productCount, text]) => {
        if (text.indexOf('no-results') != -1) {
          $('.navbar__search').addClass('search-results--no-results');
          return;
        }

        $('.navbar__search').removeClass('search-results--no-results');

        // Parse the original HTML
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search').innerHTML;

        // Update the product count in the results markup
        let updatedMarkup = resultsMarkup;
        if (productCount > 0) {
          // Replace the count in the heading
          updatedMarkup = resultsMarkup.replace(
            /(<h4>\s*)(\d+)(\s+Products?\s*<\/h4>)/i,
            `$1${productCount}$3`,
          );
        }

        this.predictiveSearchResults.innerHTML = updatedMarkup;

        window.updateProductCardsWishlist?.();

        if ($('.search__initial').is(':visible')) {
          $(this.predictiveSearchResults).hide();

          $('.search__initial').fadeOut(() => {
            this.open();
          });
        } else {
          this.open();
        }
      })
      .catch((error) => {
        console.error(error);
        this.close();
      });
  }

  open() {
    $(this.predictiveSearchResults).fadeIn();
    console.log('open');
  }

  close() {
    $(this.predictiveSearchResults).fadeOut();
    console.log('close');
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);
